<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
    status: string;
}>();

const { t } = useI18n();

const status = computed(() => props.status);
const badgeText = computed(() => t(status.value));

const severity = computed(() => {
    switch (status.value) {
        case 'EXPIRED':
            return 'info';
        case 'CANCELLED':
            return 'warning';
        case 'FAILED':
            return 'danger';
        case 'ACCEPTED':
            return 'success';
        case 'READY':
            return '';
        default:
            return '';
    }
});

const tailwindClass = computed(() => {
    switch (status.value) {
        case 'QUEUED':
            return 'bg-orange-300';
        case 'SENT':
            return 'bg-indigo-300';
        case 'UNKNOWN':
            return 'surface-600';
        default:
            return '';
    }
});
</script>

<template>
    <Badge :severity="severity" :class="tailwindClass">{{ badgeText }}</Badge>
</template>

<i18n lang="yaml">
nl:
    READY: 'Ready'
    ACCEPTED: 'Accepted'
    EXPIRED: 'Expired'
    UNKNOWN: 'Not invited'
    QUEUED: 'Queued'
    SENT: 'Sent'
    FAILED: 'Failed'
    CANCELLED: 'Cancelled'
en:
    READY: 'Ready'
    ACCEPTED: 'Accepted'
    EXPIRED: 'Expired'
    UNKNOWN: 'Not invited'
    QUEUED: 'Queued'
    SENT: 'Sent'
    FAILED: 'Failed'
    CANCELLED: 'Cancelled'
</i18n>
